/* eslint-disable import/no-cycle */

import TradeMultistepForm from './trade-multistep-form';

export default TradeMultistepForm;
